// The greeting's clock-and-name arithmetic, shared by every surface that
// leads a new chat with a salutation (dashboard SPA, widget). Pure functions
// only — no transport, no React — so each host fetches `/salutation` with its
// own auth (the SPA's bearer JWT, the widget's header pair) and renders the
// result through the shared <Salutation> component.

/** The deterministic ladder, mirroring `_fallback` in app/lib/salutation.py.
 *  Rendered immediately so the heading is never blank, and kept if the request
 *  fails. The two must agree, or the line visibly rewrites itself on arrival. */
export function fallbackSalutation(now: Date, name: string): string {
  const hour = now.getHours()
  const lead =
    now.getDay() === 5
      ? 'Happy Friday'
      : hour < 5
        ? 'Working late'
        : hour < 12
          ? 'Good morning'
          : hour < 18
            ? 'Good afternoon'
            : 'Good evening'
  return name ? `${lead}, ${name}` : lead
}

/** JS `Date.getDay()` is 0=Sunday; the API takes 0=Monday. */
export function isoWeekday(now: Date): number {
  return (now.getDay() + 6) % 7
}

/** Query string for `GET /salutation`, so the two callers can't drift on
 *  parameter names or on forgetting to encode the name. */
export function salutationQuery(weekday: number, hour: number, name: string): string {
  return `weekday=${weekday}&hour=${hour}&name=${encodeURIComponent(name)}`
}
